module.exports = __webpack_public_path__ + "img/100-won-promotion-banner.5b351f49.png";